import { SUBCLUSTERS } from '../subclusters.js';

const EDUCATION_CLUSTER = {
    subclusters: [
        {
            key: SUBCLUSTERS.REPORTING_TO_EXECUTIVES,
        },
        {
            key: SUBCLUSTERS.PROJECT_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.INDIVIDUAL_WORK,
        },
        {
            key: SUBCLUSTERS.STUDENT_ORGANIZATIONS,
        },
        {
            key: SUBCLUSTERS.ACADEMIC_RESEARCH,
        },
        {
            key: SUBCLUSTERS.GROUP_ASSIGNMENTS,
        },
        {
            key: SUBCLUSTERS.CURRICULUM_SYLLABUS_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.ADMINISTRATIVE_WORK,
        },
        {
            key: SUBCLUSTERS.TASKS,
        },
        {
            key: SUBCLUSTERS.MANAGING_ROUTINE_PROCESSES,
        },
        {
            key: SUBCLUSTERS.MANAGING_PROJECTS_PORTFOLIO,
        },
        {
            key: SUBCLUSTERS.RESOURCE_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.BUSINESS_OPERATIONS,
        },
        {
            key: SUBCLUSTERS.CRM,
        },
    ],
    mini_site: {
        logo: {
            alt: 'monday.com for education',
            url: '/education',
            src: 'https://dapulse-res.cloudinary.com/image/upload/mondayhomepage/mini-site/education/56-education-logo.png',
            mobileSrc: 'https://dapulse-res.cloudinary.com/image/upload/mondayhomepage/mini-site/education/52-education-logo.png',
            useDesktopLogoInMobile: 'true',
        },
        links: [
            {
                url: '/education/students',
                text: 'minisite.header.students',
                removeFromUnified: 'true',
            },
            {
                url: '/education/staff',
                text: 'minisite.header.staff',
            },
            {
                url: '/templates/category/education',
                text: 'minisite.header.templates',
            },
            {
                url: '/education/academic-partnerships',
                text: 'minisite.header.becomePartners',
            },
            {
                url: '/lp/academic/blogs/',
                text: 'minisite.header.blog',
            },
        ],
        unifiedDesktopLogo: {
            url: '/education',
            src: 'https://dapulse-res.cloudinary.com/image/upload/mondayhomepage/mini-site/education/84-education-logo.png',
            alt: 'monday.com for education',
        },
    },
};

export { EDUCATION_CLUSTER };
